module.exports = __webpack_public_path__ + "media/app/assets/imgs/arrow-back-0ce263f0128e0d1dcbdf2691f4193dc9.svg";